module.exports = __webpack_public_path__ + "static/fonts/fa-solid-900.896e20e.ttf";


//////////////////
// WEBPACK FOOTER
// ./static/fontawesome-5.10.2/webfonts/fa-solid-900.ttf
// module id = 343
// module chunks = 1